import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Padlock(props) {
  const purple = getColorValue('illustrationPurple');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m207.85 184.532c.87-4.9 1.33-10.1 1.33-15.61s-.46-10.86-1.35-15.82c-5.3-29.5-25.8-47.69-54.53-52.36-4.9-.7998-10.04-1.2098-15.39-1.2098s-10.93.44-16.03 1.2898c-28.76 4.8-49.21 22.94-54.52 52.27-.9 4.96-1.36 10.23-1.36 15.82s.46 10.71 1.34 15.61c5.27 29.3 25.74 47.47 54.55 52.27 5.1.85 10.45 1.29 16.03 1.29s10.49-.41 15.39-1.21c28.79-4.68 49.3-22.9 54.56-52.36z"
        fill={purple}
      />
      <path
        d="m156.92 161.662c.24-1.35.37-2.78.37-4.3s-.13-2.99-.37-4.35c-1.46-8.12-7.1-13.12-15.01-14.41-1.35-.22-2.76-.33-4.24-.33s-3.01.12-4.41.36c-7.92 1.32-13.55 6.31-15.01 14.39-.25 1.36-.38 2.82-.38 4.35s.13 2.95.37 4.3c1.45 8.06 7.09 13.07 15.01 14.39 1.4.23 2.88.36 4.41.36s2.89-.11 4.24-.33c7.92-1.29 13.57-6.3 15.02-14.41z"
        fill={illustrationColors.staticDarkBlue}
      />
      <path d="m189.62 81.7422h-104.0902v45.2898h104.0902z" fill={purple} />
      <path
        d="m150.11 166.592h-25.07v33.22h25.07z"
        fill={illustrationColors.staticDarkBlue}
      />
      <path
        d="m137.74 125.982c-3.27 0-6.5-.26-9.58-.78-19.03-3.17-31.8501-15.54-35.1501-33.9195-.54-3.02-.82-6.22-.82-9.49s.28-6.55.83-9.61c3.33-18.38 16.1301-30.74 35.1401-33.91 6.07-1.01 12.74-1.03 18.8-.05 19.04 3.1 31.87 15.48 35.19 33.98.55 3.06.83 6.29.83 9.59s-.27 6.46-.81 9.48c-3.3 18.4995-16.13 30.8895-35.2 33.9895-2.96.48-6.06.73-9.22.73zm0-79.2095c-2.74 0-5.49.21-8.05.64-15.14 2.53-24.92 11.91-27.55 26.42-.46 2.51-.69 5.19-.69 7.96s.23 5.37.67 7.85c2.61 14.5095 12.4 23.8995 27.56 26.4295 5.07.85 10.76.86 15.79.04 15.17-2.47 24.96-11.87 27.57-26.4695.44-2.49.67-5.13.67-7.85s-.23-5.44-.68-7.96c-2.62-14.6-12.41-24-27.56-26.47-2.46-.4-5.1-.6-7.74-.6z"
        fill={purple}
      />
    </svg>
  );
}

export default Padlock;
